import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { translate } from 'react-i18next';
import { Search, Role, Locked, RegistrationStatus } from './filters';
import { AccountTable } from '.';
import { OpenFileLink } from '../../../common/components/data-display';

@translate()
export default class AccountList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    accounts: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterSearchChange: PropTypes.func.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    onFilterRoleChange: PropTypes.func.isRequired,
    onFilterLockedChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
  };

  render() {
    const {
      accounts,
      pagination,
      filter,
      onTableChange,
      onFilterStatusChange,
      onFilterRoleChange,
      onFilterLockedChange,
      onFilterSearchChange,
      isLoading,
      token,
      t,
    } = this.props;
    return (
      <section>
        <h1>{t('Používatelia')}</h1>

        <Row center="xs" className="filters padded">
          <Col xs={12} sm={4}>
            <Search
              key="accountSearch"
              defaultValue={filter.search}
              onSearch={onFilterSearchChange}
            />
          </Col>
          <Col xs={12} sm={4}>
            <Role value={filter.role} onChange={onFilterRoleChange} />
            <Locked value={filter.locked} onChange={onFilterLockedChange} />
          </Col>
          <Col xs={12} sm={4}>
            <RegistrationStatus
              key="accountStatus"
              value={filter.registrationStatus}
              onChange={onFilterStatusChange}
            />
          </Col>
        </Row>

        <AccountTable
          accounts={accounts}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
        />

        <OpenFileLink
          isButton
          href={`${process.env.REACT_APP_API_URL}/account/report?token=${token}&locked=${filter.locked}&search=${filter.search}&registrationstatus=${filter.registrationStatus}&role1=${filter.role[0]}&role2=${filter.role[1]}`}
        >
          {t('Export')}
        </OpenFileLink>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/components/AccountList.js